<!--
File: product-grid-item.component.html
Project: catalog-cloud
File Created: Thursday, 17th February 2022 11:48:25
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Tuesday, 10th March 2026 7:56:21 am
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->

<div
  class="product-grid-item max-w-full border-round border-primary overflow-hidden h-12rem hover-product border-1"
  pDraggable
  (onDragStart)="dragItem($event)"
  (onDragEnd)="dragEnd($event)"
  (click)="sendProductToDetailView()"
  [class.selected]="selected"
>
  <div
    class="product-grid-item__image"
    [lazyBg]="item.img"
  ></div>
  <div class="product-info-bar">
    <div class="overflow-hidden max-w-full">
      <div class="overflow-hidden white-space-nowrap text-overflow-ellipsis font-bold">
        <span>{{ item.name }}</span>
      </div>
      <div>
        <span class="product-sku font-bold">Sku: {{ item.sku }}</span>
      </div>
    </div>
  </div>
</div>
